module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Discovery-Of-Witches-A-S1.28d9309.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Discovery-Of-Witches-A-S1.jpg
// module id = QgwG
// module chunks = 0